import { render, staticRenderFns } from "./Pemerintah.vue?vue&type=template&id=174df732&"
import script from "./Pemerintah.vue?vue&type=script&lang=js&"
export * from "./Pemerintah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports